<template>
    <div class="login-box">
        <div class="login">
            <div class="login-title">Registrarse/Iniciar sesión</div>
            <div class="login-subtitle">Número de teléfono</div>
            <div :class="['input-box', errorTel ? 'input-error' : '']">
                <img src="@/assets/image/icon-phone.webp" alt="" />
                <div class="line"></div>
                <!-- <Input
                    v-model="telephone"
                    class="input"
                    placeholder="Número de teléfono de 10 dígitos"
                    clearable
                    type="tel"
                    :border="false"
                    @on-keydown="handleInput"
                    @on-blur="handleBlur"
                    :maxlength="10"
                /> -->
                <input
                    class="input"
                    v-model="telephone"
                    :maxlength="10"
                    placeholder="Número de teléfono de 10 dígitos"
                    onkeyup="value = value.replace(/\D/g, '')"
                />
            </div>
            <div class="tel-error" v-if="errorTel">
                Número de teléfono incorrecto
            </div>
            <div class="login-subtitle">Código de verificación</div>
            <div :class="['input-box', errorCode ? 'input-error' : '']">
                <img src="@/assets/image/icon-code.webp" alt="" />
                <div class="line"></div>
                <!-- <Input
                    v-model="code"
                    class="input"
                    placeholder="El código recibido"
                    clearable
                    :border="false"
                    @on-keydown="handleInput"
                /> -->
                <input
                    class="input"
                    v-model="code"
                    :maxlength="4"
                    placeholder="El código recibido"
                    onkeyup="value = value.replace(/\D/g, '')"
                />
                <div class="time-btn" @click="getYzCode" v-if="codeTime">
                    {{ codeTime }}s
                </div>
                <div class="code-btn" @click="getYzCode" v-else>Obtener</div>
            </div>
            <div
                :class="[
                    'login-btn',
                    telephone.length == 10 && code.length == 4
                        ? ''
                        : 'login-useless',
                ]"
                @click="login"
            >
                Confirmar
            </div>
            <div class="login-rule">
                <img
                    src="@/assets/image/radio-true.webp"
                    alt=""
                    v-if="isAgree"
                    @click="isAgree = false"
                />
                <img
                    src="@/assets/image/radio-false.webp"
                    alt=""
                    v-else
                    @click="isAgree = true"
                />
                <span
                    >He leído y acepto los
                    <u @click="pactVisible = true"
                        >Términos y Condiciones</u
                    ></span
                >
            </div>
            <div class="login-error" v-if="errorCode">
                Introduce el número de teléfono y el código de verificación.
            </div>
        </div>
        <Modal
            v-model="pactVisible"
            :footer-hide="true"
            width="1000"
            class-name="vertical-center-modal"
        >
            <template slot="close">
                <img
                    class="icon-close"
                    src="@/assets/image/icon-close.webp"
                    alt=""
                />
            </template>
            <div class="pact-box">
                <div class="pact-header">
                    <div class="pact-title">Términos y condiciones</div>
                </div>
                <div class="pact">
                    <UserPact></UserPact>
                </div>
            </div>
        </Modal>
    </div>
</template>
<script>
import UserPact from "./userPact.vue";
import http from "@/request/api";
export default {
    components: {
        UserPact,
    },
    data() {
        return {
            telephone: "",
            code: "",
            isAgree: false,
            errorTel: false,
            errorCode: false,
            codeTime: 0,
            interval: null,
            pactVisible: false,
        };
    },
    watch: {
        telephone() {
            if (this.codeTime > 0) {
                clearInterval(this.interval);
                this.codeTime = 0;
            }
        },
    },
    methods: {
        async getYzCode() {
            if (this.codeTime > 0) {
                return;
            }
            if (this.telephone.length == 10) {
                let { data } = await http.getCode({
                    mobile: "+57" + this.telephone,
                });
                if (data.code == 0) {
                    this.errorTel = false;
                    this.codeTime = 60;
                    this.interval = setInterval(() => {
                        if (this.codeTime > 0) {
                            this.codeTime--;
                        } else {
                            clearInterval(this.interval);
                        }
                    }, 1000);
                }
                console.log(data);
            } else {
                this.errorTel = true;
            }
        },
        async login() {
            if (this.telephone.length != 10) {
                // this.errorTel = true
                return;
            }
            this.errorTel = false;
            if (this.code.length != 4) {
                // this.errorCode = true
                return;
            }
            this.errorCode = false;
            if (!this.isAgree) {
                this.$Message.error(
                    "Por favor, acepta los Términos y Condiciones primero."
                );
                return;
            }
            let { data } = await http.login({
                mobile: "+57" + this.telephone,
                code: this.code,
                platform: "website",
            });
            if (data.code == 0) {
                sessionStorage.setItem("TranToken", data.data.token);
                this.$store.commit("setOnline");
                location.reload();
            }
            //  else {
            //     return;
            // }
            // let list = await http.ordersList({});
            // if (list.data.code == 0) {
            //     sessionStorage.setItem("TranName", list.data.data.userName);
            //     this.$store.commit("setUserName", list.data.data.userName);
            //     this.$Message.success("Inicio de sesión exitoso");
            //     this.$emit("loginSuccess");
            // }
            // sessionStorage.setItem(
            //     "TranToken",
            //     "4c9c82def86a4ba890c8793360f31ea8"
            // );
            // this.$store.commit("setOnline", true);
            // sessionStorage.setItem("TranName", "freedom");
            // this.$store.commit("setUserName", "freedom");
            // this.$emit("loginSuccess");
        },
    },
};
</script>
<style lang="less" scoped>
.login-box {
    width: 1000px;
    height: 540px;
    background-image: url("@/assets/image/login-bg.webp");
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: top right;
}
.login {
    width: 512px;
    height: 100%;
    padding-left: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .login-title {
        width: 336px;
        height: 46px;
        padding-left: 16px;
        font-weight: 600;
        font-size: 26px;
        color: #000000;
        line-height: 46px;
        position: relative;
    }
    .login-title::before {
        content: "";
        display: block;
        width: 6px;
        height: 30px;
        background: #ffe955;
        position: absolute;
        left: 0;
        top: 8px;
    }
    .login-subtitle {
        width: 376px;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        margin-top: 20px;
    }
    .input-box {
        width: 376px;
        height: 50px;
        background: #f0f0f0;
        border-radius: 4px;
        margin-top: 12px;
        padding-left: 14px;
        padding-right: 7px;
        display: flex;
        align-items: center;
        img {
            width: 24px;
        }
        .line {
            width: 1px;
            height: 20px;
            background: #999999;
            margin: 0 10px;
        }
        .code-btn {
            width: 108px;
            height: 36px;
            background: #ffe955;
            border-radius: 4px;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            text-align: center;
            line-height: 36px;
            cursor: pointer;
        }
        .time-btn {
            width: 108px;
            height: 36px;
            background: #cccccc;
            border-radius: 4px;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            text-align: center;
            line-height: 36px;
            cursor: pointer;
        }
        .input {
            flex: 1;
            background: #f0f0f0;
            outline: none;
            border: none;
        }
    }
    .input-error {
        border: 1px solid #ef6565;
    }
    .tel-error {
        width: 376px;
        font-weight: 500;
        font-size: 14px;
        color: #ff7878;
        margin-top: 8px;
    }
    .login-btn {
        width: 376px;
        height: 60px;
        background: #ffe955;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        border-radius: 8px 8px 8px 8px;
        font-weight: 600;
        font-size: 20px;
        color: #000000;
        text-align: center;
        line-height: 60px;
        margin-top: 40px;
        cursor: pointer;
    }
    .login-useless {
        background: #cccccc;
    }
    .login-rule {
        display: flex;
        align-items: center;
        margin-top: 22px;
        img {
            width: 24px;
            height: 24px;
            cursor: pointer;
        }
        span {
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            margin-left: 4px;
            u {
                cursor: pointer;
            }
        }
    }
    .login-error {
        font-weight: 500;
        font-size: 14px;
        color: #ff7878;
        margin-top: 12px;
    }
}

.pact-box {
    width: 100%;
    height: 650px;
    background: linear-gradient(180deg, #fef1b6 0%, #ffffff 27%);
    border-radius: 16px;
    .pact-header {
        width: 100%;
        height: 106px;
        padding-top: 40px;
        display: flex;
        justify-content: center;
        border-bottom: 1px solid #cccccc;
        .pact-title {
            // width: 505px;
            // height: 46px;
            padding-left: 16px;
            font-weight: 600;
            font-size: 26px;
            color: #000000;
            line-height: 46px;
            position: relative;
            margin-bottom: 20px;
        }
        .pact-title::before {
            content: "";
            display: block;
            width: 6px;
            height: 30px;
            background: #ffe955;
            position: absolute;
            left: 0;
            top: 8px;
        }
    }
    .pact {
        width: 880px;
        height: 500px;
        margin: 20px auto;
        padding: 20px;
        overflow-x: hidden;
        overflow-y: scroll;
        background: #f4f4f4;
        border-radius: 10px;
    }
}
.icon-close {
    width: 40px;
}
/deep/ .ivu-modal-body {
    padding: 0;
}
/deep/ .ivu-modal-content {
    border-radius: 16px;
}
/deep/ .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
        top: 0;
    }
}
</style>
